import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsPopoverCss = ":host{--sizing-max-width-default:352px;display:inline-block}:host [popover]{background-color:var(--pine-color-background-container);border:var(--pine-border);border-radius:10px;-webkit-box-shadow:var(--pine-box-shadow-200);box-shadow:var(--pine-box-shadow-200);margin:var(--pine-dimension-none);max-width:var(--sizing-max-width-default);padding:var(--pine-dimension-md);position:fixed}:host button{-ms-flex-align:center;align-items:center;background-color:var(--pine-color-secondary);border:var(--pine-border);border-radius:var(--pine-border-radius-full);color:var(--pine-color-text-secondary);display:-ms-flexbox;display:flex;font:var(--pine-typography-body-medium);font-family:var(--pine-font-family-heading);letter-spacing:var(--pine-letter-spacing);min-height:40px;padding:var(--pine-dimension-xs) var(--pine-dimension-sm)}:host button:hover{background-color:var(--pine-color-secondary-hover)}";
const PdsPopoverStyle0 = pdsPopoverCss;

const PdsPopover$1 = /*@__PURE__*/ proxyCustomElement(class PdsPopover extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.active = false;
        this.popoverTargetAction = 'show';
        this.popoverType = 'auto';
        this.componentId = undefined;
        this.text = undefined;
        this.maxWidth = 352;
        this.placement = 'right';
    }
    componentWillRender() {
        this.handlePopoverPositioning();
    }
    handleClick() {
        this.active = !this.active;
    }
    handleScroll() {
        if (this.active) {
            this.handlePopoverPositioning();
        }
    }
    handlePopoverPositioning() {
        const triggerEl = this.el.shadowRoot.querySelector('.pds-popover__trigger');
        const popoverEl = this.el.shadowRoot.querySelector('div[popover]');
        if (!triggerEl || !popoverEl)
            return;
        const triggerRect = triggerEl.getBoundingClientRect();
        const popoverRect = popoverEl.getBoundingClientRect();
        let top = 0;
        let left = 0;
        const offset = 8;
        switch (this.placement) {
            case 'top':
                top = triggerRect.top - popoverRect.height - offset;
                left = triggerRect.left;
                break;
            case 'right':
                top = triggerRect.top;
                left = triggerRect.right + offset;
                break;
            case 'bottom':
                top = triggerRect.bottom + offset;
                left = triggerRect.left;
                break;
            case 'left':
                top = triggerRect.top;
                left = triggerRect.left - popoverRect.width - offset;
                break;
        }
        popoverEl.style.top = `${top}px`;
        popoverEl.style.left = `${left}px`;
    }
    render() {
        return (h(Host, { key: '7a21719bb6f13f435cae77f6b2c7c2eefb36c977' }, h("button", { key: '707c94e2462fe230a777d61899b902c84feaa09c', class: "pds-popover__trigger", popoverTarget: this.componentId, popoverTargetAction: this.popoverTargetAction, onClick: this.handleClick }, this.text), h("div", { key: '703d21dd5f3caadb8c0d097849f691d2d4407358', class: `pds-popover ${this.active ? 'pds-popover--active' : ''}`, id: this.componentId, popover: this.popoverType, style: { maxWidth: `${this.maxWidth}px` } }, h("slot", { key: '42ef680b5850d62f50f1e6cfb1587c3d5b6db0d4' }))));
    }
    get el() { return this; }
    static get style() { return PdsPopoverStyle0; }
}, [1, "pds-popover", {
        "popoverTargetAction": [1, "popover-target-action"],
        "popoverType": [1, "popover-type"],
        "componentId": [1, "component-id"],
        "text": [1],
        "maxWidth": [2, "max-width"],
        "placement": [513],
        "active": [32]
    }, [[2, "click", "handleClick"], [11, "scroll", "handleScroll"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-popover"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-popover":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsPopover$1);
            }
            break;
    } });
}

const PdsPopover = PdsPopover$1;
const defineCustomElement = defineCustomElement$1;

export { PdsPopover, defineCustomElement };

//# sourceMappingURL=pds-popover.js.map